module.exports = new __parcel__URL__("illustrationForGa.b8394158.svg").toString();